var render = function render(){var _vm=this,_c=_vm._self._c;return _c('detail',{attrs:{"on-manager":_vm.onManager,"data":_vm.data,"base-info":_vm.baseInfo,"resource":"billing_skus"}})
}
var staticRenderFns = []

export { render, staticRenderFns }